import { Link as ReactRouterLink } from 'react-router-dom'
import { Link as ChakraLink } from '@chakra-ui/react'
import { Text } from "@chakra-ui/react"
import { useAuth } from '../../context/AuthContext'
import { Ellipsis } from 'brokertslib/src/components'

export const OrganizationLink = ({ id, name, sx, showId = false }:
    { id?: number, name?: string, sx?: {}, showId?: boolean }) => {
    const auth = useAuth()

    const to = auth?.user?.ouId === id ? '/organization' : `/organization/${id}`

    return (
        <ChakraLink as={ReactRouterLink} to={to}>
            <Ellipsis sx={sx}>
                <Text>{name}{showId && id && `, Id: ${id}`}</Text>
            </Ellipsis>
        </ChakraLink>
    )
}

export const OrganizationLinkPlain = ({ id, name, sx, showId = false }:
    { id?: number, name?: string, sx?: {}, showId?: boolean }) => {
    const auth = useAuth()

    const to = auth?.user?.ouId === id ? '/organization' : `/organization/${id}`

    return (
        <ChakraLink as={ReactRouterLink} to={to} sx={sx}>
            {name}{showId && id && `, Id: ${id}`}
        </ChakraLink>
    )
}